import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  type SuppliersOverviewCountsQueryParams,
  type SuppliersOverviewCountsResponse,
} from './types';
import {
  zodSuppliersOverviewCountsQueryParamsSchema,
  zodSuppliersOverviewCountsResponseSchema,
} from './validations';

/**
 * Fetches per-status-group supplier counts for the supplier overview.
 *
 * All query parameter keys are camelCase and are automatically converted to
 * snake_case by the ky case-converter before the request is sent.
 *
 * @param queryParams - Optional filter parameters (mirrors the overview filters, without pagination).
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The status-group count response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-overview/operation/get_suppliers_overview_counts_suppliers_views_counts_get
 */
export const fetchSuppliersOverviewCounts = async (
  queryParams: Partial<SuppliersOverviewCountsQueryParams>,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SUPPLIER.GET_OVERVIEW_COUNTS(), {
      ...options,
      searchParams: queryParams,
      validate: {
        response: zodSuppliersOverviewCountsResponseSchema,
        searchParams: zodSuppliersOverviewCountsQueryParamsSchema.transform(
          (value) =>
            withoutObjectKeysWhereValueIs(value, [null, undefined, '']),
        ),
      },
    })
    .json<SuppliersOverviewCountsResponse>();
